/**
 * sections-main-search-index.js
 * 搜索页 (main-search) 筛选、排序、价格区间、布局切换等交互
 */
document.addEventListener('DOMContentLoaded', function() {
  var linkDropdownButton = document.querySelector('.link-dropdown__button');
  if (linkDropdownButton) {
    var linkDropdown = linkDropdownButton.closest('.link-dropdown');
    linkDropdownButton.addEventListener('click', function(e) {
      e.stopPropagation();
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
    document.addEventListener('click', function(e) {
      if (linkDropdown && !linkDropdown.contains(e.target)) {
        linkDropdownButton.setAttribute('aria-expanded', 'false');
      }
    });
  }

  var filterForm = document.getElementById('CollectionFilterForm');
  if (filterForm) {
    filterForm.addEventListener('change', function(e) {
      var target = e.target;
      if (target.classList.contains('hete-group-checkbox') && !target.classList.contains('filter-group__checkbox--sort')) {
        if (target.checked) {
          setTimeout(function() {
            var applied = document.querySelectorAll('.hete-grop_applied-item');
            var arr = [];
            for (var i = applied.length - 1; i >= 0; i--) {
              var text = (applied[i].textContent || '').trim();
              if (text.indexOf(',') >= 0) text = text.replace(',', '');
              arr[i] = text;
            }
            if (window.dataLayer) {
              window.dataLayer.push({ ecommerce: null });
              var labelEl = target.parentElement && target.parentElement.querySelector('.hete-group-text');
              window.dataLayer.push({
                event: 'uaEvent',
                ht_event_id: '28',
                event_type: 'product_filter',
                filter_type: 'product_type',
                event_label: labelEl ? labelEl.textContent : '',
                applied_filters: arr.join(',')
              });
            }
          }, 3000);
          setTimeout(function() {
            if (window.setGoogleBuried) {
              window.setGoogleBuried({ type: 'initViewItemList24' });
            }
          }, 3000);
        }
      } else if (target.getAttribute('name') === 'sort_by' && target.classList.contains('filter-group__checkbox--sort') && target.checked) {
        if (window.dataLayer) {
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'uaEvent',
            ht_event_id: '27',
            event_type: 'product_sort',
            event_label: target.getAttribute('data-option-name') || ''
          });
        }
      }
      if (target.matches('input[name][type="checkbox"], input[name="sort_by"]')) {
        filterForm.submit();
      }
      if (target.classList.contains('hete-price-min') || target.classList.contains('hete-price-max')) {
        filterForm.submit();
      }
    });
  }

  function initPriceRange(container) {
    var inputMin = container.querySelector('.cc-price-range__input--min');
    var inputMax = container.querySelector('.cc-price-range__input--max');
    var controlMin = container.querySelector('.cc-price-range__control--min');
    var controlMax = container.querySelector('.cc-price-range__control--max');
    var bar = container.querySelector('.cc-price-range__bar');
    var activeBar = container.querySelector('.cc-price-range__bar-active');
    if (!inputMin || !inputMax || !controlMin || !controlMax || !bar || !activeBar) return;

    var valueMin = parseInt(inputMin.getAttribute('min') || '0', 10);
    var valueMax = parseInt(inputMin.getAttribute('max') || inputMax.getAttribute('max') || inputMax.placeholder || '100', 10);
    if (valueMax <= valueMin) valueMax = valueMin + 100;

    var getVal = function(input, fallback) {
      var v = parseInt(input.value, 10);
      return isNaN(v) ? fallback : v;
    };

    var minVal = getVal(inputMin, valueMin);
    var maxVal = getVal(inputMax, valueMax);
    minVal = Math.max(valueMin, Math.min(minVal, maxVal));
    maxVal = Math.min(valueMax, Math.max(maxVal, minVal));

    var pcRatio = 100 / (valueMax - valueMin);
    var rtl = document.querySelector('html[dir="rtl"]');

    function render() {
      var sMin = (minVal - valueMin) * pcRatio;
      var sMax = (maxVal - valueMin) * pcRatio;
      if (rtl) {
        controlMin.style.right = sMin + '%';
        controlMin.style.left = '';
        controlMax.style.right = sMax + '%';
        controlMax.style.left = '';
        activeBar.style.left = (100 - sMax) + '%';
        activeBar.style.right = sMin + '%';
      } else {
        controlMin.style.left = sMin + '%';
        controlMax.style.left = sMax + '%';
        activeBar.style.left = sMin + '%';
        activeBar.style.right = (100 - sMax) + '%';
      }
    }

    function setMinValue(v) {
      v = Math.round(v);
      v = Math.max(valueMin, Math.min(v, maxVal));
      minVal = v;
      inputMin.value = v === valueMin && inputMin.placeholder ? '' : String(v);
      render();
    }

    function setMaxValue(v) {
      v = Math.round(v);
      v = Math.min(valueMax, Math.max(v, minVal));
      maxVal = v;
      inputMax.value = v === valueMax && inputMax.placeholder ? '' : String(v);
      render();
    }

    render();

    var activeControl = null;
    var dragStartX = 0;
    var dragStartVal = 0;
    var barWidth = bar.offsetWidth;
    var pxToVal = barWidth / (valueMax - valueMin);

    function moveDrag(clientX) {
      if (!activeControl) return;
      var delta = clientX - dragStartX;
      if (rtl) delta = -delta;
      var newVal = dragStartVal + delta / pxToVal;
      if (activeControl === 'min') setMinValue(newVal);
      else setMaxValue(newVal);
    }

    function endDrag() {
      if (activeControl && filterForm) {
        filterForm.submit();
      }
      activeControl = null;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    }

    function onMouseMove(e) { moveDrag(e.clientX); }
    function onMouseUp() { endDrag(); }
    function onTouchMove(e) { e.preventDefault(); moveDrag(e.touches[0].clientX); }
    function onTouchEnd(e) { e.preventDefault(); endDrag(); }

    function startDrag(control, clientX) {
      barWidth = bar.offsetWidth;
      pxToVal = barWidth / (valueMax - valueMin);
      if (control === controlMin) {
        activeControl = 'min';
        dragStartVal = minVal;
      } else {
        activeControl = 'max';
        dragStartVal = maxVal;
      }
      dragStartX = clientX;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('touchend', onTouchEnd);
    }

    controlMin.addEventListener('mousedown', function(e) { e.preventDefault(); startDrag(controlMin, e.clientX); });
    controlMax.addEventListener('mousedown', function(e) { e.preventDefault(); startDrag(controlMax, e.clientX); });
    controlMin.addEventListener('touchstart', function(e) { e.preventDefault(); startDrag(controlMin, e.touches[0].clientX); }, { passive: false });
    controlMax.addEventListener('touchstart', function(e) { e.preventDefault(); startDrag(controlMax, e.touches[0].clientX); }, { passive: false });

    inputMin.addEventListener('change', function() {
      var v = getVal(inputMin, valueMin);
      setMinValue(v);
    });
    inputMax.addEventListener('change', function() {
      var v = getVal(inputMax, valueMax);
      setMaxValue(v);
    });
  }

  document.querySelectorAll('.cc-price-range').forEach(initPriceRange);

  function handleToggleTarget(e) {
    var toggler = e.target.closest('a[data-toggle-target]');
    if (!toggler || !toggler.dataset.toggleTarget) return;
    if (!toggler.closest('[data-section-type="search-template"]')) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var target = document.querySelector(toggler.dataset.toggleTarget);
    if (!target) return;
    var transCont = target.querySelector('.toggle-target-container');
    var doCollapse = !target.classList.contains('toggle-target--hidden');
    var duration = 300;
    var style = window.getComputedStyle(target);
    if (style.transitionDuration) {
      var d = parseFloat(style.transitionDuration);
      duration = style.transitionDuration.indexOf('ms') >= 0 ? d : d * 1000;
    }
    if (target.classList.contains('toggle-target--in-transition')) return;

    if (doCollapse) {
      toggler.classList.add('toggle-target-toggler--is-hidden');
      target.classList.add('toggle-target--in-transition', 'toggle-target--hiding');
      var startHeight = transCont ? transCont.offsetHeight : 0;
      target.style.height = startHeight + 'px';
      target.style.opacity = '1';
      target.style.display = 'block';
      requestAnimationFrame(function() {
        target.style.height = '0';
        target.style.opacity = '0';
        setTimeout(function() {
          target.classList.add('toggle-target--hidden');
          target.classList.remove('toggle-target--in-transition', 'toggle-target--hiding');
          target.style.display = 'none';
          target.style.height = '';
          target.style.opacity = '';
        }, duration);
      });
    } else {
      toggler.classList.remove('toggle-target-toggler--is-hidden');
      target.classList.add('toggle-target--in-transition', 'toggle-target--revealing');
      target.style.height = '0';
      target.style.opacity = '0';
      target.style.display = 'block';
      setTimeout(function() {
        var endHeight = transCont ? transCont.offsetHeight : 0;
        target.style.height = endHeight + 'px';
        target.style.opacity = '1';
        setTimeout(function() {
          target.classList.remove('toggle-target--hidden', 'toggle-target--in-transition', 'toggle-target--revealing');
          target.style.height = '';
          target.style.opacity = '';
          target.style.display = '';
        }, duration);
      }, 10);
    }
  }
  document.addEventListener('click', handleToggleTarget, true);

  function handleToggleFilters(e) {
    var btn = e.target.closest('[data-toggle-filters]');
    if (!btn) return;
    if (!btn.closest('[data-section-type="search-template"]')) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var section = document.querySelector('[data-section-type="search-template"]');
    if (!section) return;
    var filterContainer = section.querySelector('.filter-container');
    if (!filterContainer) return;
    filterContainer.classList.toggle('filter-container--show-filters-desktop');
    filterContainer.classList.toggle('filter-container--show-filters-mobile');
    var isNowVisible = filterContainer.classList.contains('filter-container--show-filters-desktop');
    section.querySelectorAll('.toggle-btn[data-toggle-filters]').forEach(function(t) {
      t.classList.toggle('toggle-btn--revealed-desktop', isNowVisible);
    });
  }
  document.addEventListener('click', handleToggleFilters, true);

  var filterContainer = document.querySelector('[data-section-type="search-template"] .filter-container');
  if (filterContainer) {
    filterContainer.classList.add('filter-container--mobile-initialised');
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.layout-switch');
    if (!btn || !btn.closest('[data-section-type="search-template"]')) return;
    e.preventDefault();
    var section = document.querySelector('[data-section-type="search-template"]');
    if (!section) return;
    var productList = section.querySelector('.product-list');
    if (!productList) return;
    if (btn.classList.contains('layout-switch--one-column')) {
      productList.classList.remove('product-list--per-row-mob-2');
      productList.classList.add('product-list--per-row-mob-1');
    } else if (btn.classList.contains('layout-switch--two-columns')) {
      productList.classList.remove('product-list--per-row-mob-1');
      productList.classList.add('product-list--per-row-mob-2');
    }
    btn.classList.add('layout-switch--active');
    var siblings = btn.parentElement.querySelectorAll('.layout-switch');
    siblings.forEach(function(s) { if (s !== btn) s.classList.remove('layout-switch--active'); });
  });
});
